module.exports = __webpack_public_path__ + "static/img/bg-id.f19dff72.png";